import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { UnitsList } from '../app/components/unit/units-list';
import { ProtectedRoute } from '@org/ui';

export const Route = createFileRoute('/units')({
  component: UnitsRoute,
});

function UnitsRoute() {
  const navigate = useNavigate({ from: '/units' });

  return (
    <ProtectedRoute requiredPermissions={['admin:all', 'units:*', 'classes:write']}>
      <div className="space-y-6">
        <UnitsList
          onCreateUnit={() => navigate({ to: '/units/new' })}
          onEditUnit={(unit) =>
            navigate({ to: '/units/$unitId', params: { unitId: unit.unitId } })
          }
        />
        <Outlet />
      </div>
    </ProtectedRoute>
  );
}


